import { Ds } from "@accurx/design";
import styled from "styled-components";

export const StyledErrorContainer = styled(Ds.Flex).attrs({
    gap: "0.25",
    alignItems: "center",
})`
    // Align inner textarea: 2px padding from user agent + 1px border of this component
    margin-left: -3px;
    margin-right: -3px;
`;
